"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _Close = _interopRequireDefault(require("@p24/icons/Close"));

function _default(palette) {
  return {
    appearance: _Close["default"],
    overlayBackground: 'rgba(0, 0, 0, 0.3)',
    overlayZIndex: palette.zMaximal,
    background: palette.elPrimary,
    borderRadius: '3px',
    overflow: 'visible',
    boxShadow: "0 8px 12px 0 ".concat(palette.elShadow, ", 0 6px 12px 0 ").concat(palette.elShadow)
  };
}